/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { PersonalData } from '../../../types/PersonalData';
import { MisDatosHelper } from '../MisDatosHelper';
import IconBack from '../../../Icons/IconBack';
import { useMisDatosStore } from '../context/MisDatos.context';
import { MisDatosConstants } from '../../../utils/MisDatosConstants';
import { useAuthStore as useAuthStoreEroski } from '../../../store/AuthContext';
import DataService from '../../../services/MisDatosService';
import useAPIError from '../../../hooks/useAPIError';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';
import { StorageHelper } from '../../../utils/StorageHelper';
import { CryptoUtil } from '../../../utils/CryptoUtil';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { FooterConstants } from '../../../utils/FooterConstants';
import { HostProvider } from '../../../utils/HostProvider';

interface Props {
  userForm?: boolean;
  passForm?: boolean;
  setUserForm?: (userForm: boolean) => void;
  setPassForm?: (passForm: boolean) => void;
  accessEmail?: string;
  cargarData?: () => void;
  personalData: PersonalData;
  dobleVerificacion: boolean;
}

const obfuscateEmail = (email: string): string => {
  const [localPart, domain] = email.split('@');
  let obfuscatedLocal = '';
  if (localPart.length > 6) {
    const asterisks = '*'.repeat(localPart.length - 4);
    obfuscatedLocal = `${localPart.slice(0, 1)}${asterisks}${localPart.slice(
      -3,
    )}`;
    return `${obfuscatedLocal}@${domain}`;
  }
  return obfuscatedLocal;
};

const ContactEmailForm: FC<Props> = (props) => {
  const { personalData, dobleVerificacion } = props;
  const {
    hideModalContactEmail,
    showModalContactEmailV2P,
  } = useMisDatosStore();
  const { t } = useTranslation();
  const misDatosHelper = new MisDatosHelper();
  const { addError } = useAPIError();
  const dataUser = useAuthStoreEroski();
  const isApp = dataUser.user.isApp === 'true';
  const isCaprabo = HostProvider.isCaprabo();
  const {
    formState: { errors },
    register,
    handleSubmit,
    getValues,
  } = useForm({
    mode: 'onChange',
  });

  const [emailContactoCambiado, setEmailContactoCambiado] = useState(false);
  const [mostrarContactEmailForm, setMostrarContactEmailForm] = useState(true);
  const title = t('datos.personaldata.modal-email-confirmacion-title');
  const text1 = t(
    'datos.personaldata.modal-email-confirmacion-invalido-message1',
  );
  const text2 = t('datos.personaldata.modal-email-confirmacion-message2');
  const text3 = t('datos.personaldata.modal-email-confirmacion-message1');
  const acceptButtonTextKey = t('entendido');
  const [textForModalCambioEmail, setTextForModalCambioEmail] = useState(
    '' as string,
  );
  const [aplicarStyle, setAplicarStyle] = useState(false);
  const getHTMLContent = () => {
    const telefonoLink = isCaprabo
      ? FooterConstants.TELEFONO_ATENCION_CLIENTE_CAPRABO
      : FooterConstants.TELEFONO_ATENCION_CLIENTE;
    return `${t(
      'datos.personaldata.modal-email-confirmacion-invalido-message3',
    )}<a href="tel:${telefonoLink.replace(
      /\s+/g,
      '',
    )}" style="color: #4a90e2; text-decoration: none;">${telefonoLink}</a>${t(
      'datos.personaldata.modal-email-confirmacion-invalido-message4',
    )}`;
  };

  const acceptEmailSend = () => {
    hideModalContactEmail();
  };

  const updateEmail = () => {
    const email = getValues('emailContacto');
    if (personalData.emailContacto !== email) {
      if (dobleVerificacion) {
        console.log('V2P activo');
        const newData = {
          emailContacto: getValues('emailContacto'),
          fromApp: isApp ? 'app_club' : 'web',
          tipoCambioMail: personalData.tipoCambioMail,
          tipoUsuario: personalData.tipoUsuario,
          version: null,
        };
        DataService.updatePersonalEmailContacto(newData)
          .then((response) => {
            if (!response.data.error) {
              setTextForModalCambioEmail(t(text3) + t(text2));
              setEmailContactoCambiado(true);
              document.body.classList.remove('fix');
              setMostrarContactEmailForm(false);
            } else {
              addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
            }
          })
          .catch((er: any) => {
            console.log(er);
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          });
      } else {
        console.log('V2P no activo');
        const prefijo = misDatosHelper.setPrefijoTelefono(
          personalData.prefijoTelefono,
        );
        const data = {
          prefijo: prefijo,
          telefono: personalData.telefono,
          tipo: 'AC',
          fromApp: isApp ? 'app_club' : 'web',
          version: '',
          idDispositivo: '',
          longitud: '',
          latitud: '',
          mobileDevice: false,
          ip: '',
          flujo: 'CO-TV',
          email: getValues('emailContacto'),
        };
        DataService.checkPrevalidacionTelefono(data)
          .then((response) => {
            if (response.data.error) {
              if (
                response.data.errorCode ===
                ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
              ) {
                const emailOfuscado = obfuscateEmail(
                  personalData.emailContacto,
                );
                setTextForModalCambioEmail(
                  `${t(text1)} ${emailOfuscado} ${t(
                    text2,
                  )} ${getHTMLContent()}`,
                );
                setEmailContactoCambiado(true);
                document.body.classList.remove('fix');
                setMostrarContactEmailForm(false);
              } else {
                addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
              }
            } else {
              StorageHelper.setNuevoEmailContacto(
                btoa(CryptoUtil.encryptAes(data.email)),
              );
              showModalContactEmailV2P();
              document.body.classList.remove('fix');
              // hideModalContactEmail();
            }
          })
          .catch((er: any) => {
            console.log(er);
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          });
      }
    }
  };

  useEffect(() => {
    const source = StorageHelper.getCambioEmailComInv();
    if (source) {
      DataService.updateCambioEmailComunicacionTelefonoInvalido()
        .then((response) => {
          if (response.data.error) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          } else {
            StorageHelper.setCambioEmailComInv('false');
            setTextForModalCambioEmail(t(text3) + t(text2));
            setEmailContactoCambiado(true);
            document.body.classList.remove('fix');
          }
        })
        .catch((er: any) => {
          console.log(er);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
        });
    }
  }, [addError, t, text3, text2]);

  useEffect(() => {
    setAplicarStyle(true);
    return () => {
      document.body.classList.remove('fix');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cambiarStyle = () => {
    setAplicarStyle(false);
    setTimeout(() => {
      hideModalContactEmail();
    }, 300);
  };

  return (
    <>
      {mostrarContactEmailForm ? (
        <section
          id="section"
          className={`o-section--large email-form
                 bloque-form ${aplicarStyle ? 'visible' : ''}`}
        >
          <div className="container">
            <a
              id="acceso-back"
              href="#contact-mail"
              onClick={() => {
                cambiarStyle();
              }}
              className="link-prev"
            >
              <div className="icon icon-medium">
                <IconBack />
              </div>
              <p className="u-font-normal u-text-brand u-margin-left">
                {t('datos.accessdata.back')}{' '}
              </p>
            </a>
            <form
              id="form-email-contacto"
              className="form-datos"
              onSubmit={handleSubmit(updateEmail)}
            >
              <fieldset>
                <h2 className="bloque-datos__title u-text-brand">
                  <span className="divider__square brand-color" />
                  <span className="u-margin-right">
                    {t('datos.contactData.label-actual-email-title')}{' '}
                  </span>
                </h2>
                <p className="u-margin-bottom">
                  {t('datos.contactData.label-actual-email-contacto')}{' '}
                  <strong>{personalData?.emailContacto}</strong>
                </p>
                <div className="row u-justify-content-space-between">
                  <div className="col-12 col-sm-5">
                    <div className="form-group u-margin-bottom-large">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="emailContacto" className="control-label">
                        {t('datos.contactData.label-new-email')}
                      </label>
                      <div className="form-control-block">
                        <input
                          type="email"
                          className={`form-control ${
                            errors.emailContacto ? 'error' : ''
                          }`}
                          id="emailContacto"
                          maxLength={MisDatosConstants.MAX_LENGTH_EMAIL}
                          {...register('emailContacto', {
                            required: true,
                            pattern: misDatosHelper.getExpresionRegularEmail(),
                            validate: {
                              valid: (value) =>
                                misDatosHelper.isAsciiPrintableEmail(value),
                              corporativeMail: (value) =>
                                misDatosHelper.isCorporativeEmail(value),
                            },
                          })}
                        />
                        {errors.emailContacto &&
                          errors.emailContacto.type === 'required' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="emailContacto-error"
                              className="error"
                              htmlFor="emailContacto"
                            >
                              {t('validaciones.empty-value')}
                            </label>
                          )}
                        {errors.emailContacto &&
                          errors.emailContacto.type === 'pattern' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="emailContacto-error"
                              className="error"
                              htmlFor="emailContacto"
                            >
                              {t('validaciones.not-valid-email')}
                            </label>
                          )}
                        {errors.emailContacto &&
                          errors.emailContacto.type === 'valid' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="emailContacto-error"
                              className="error"
                              htmlFor="emailContacto"
                            >
                              {t('validaciones.not-valid-value')}
                            </label>
                          )}
                        {errors.emailContacto &&
                          errors.emailContacto.type === 'corporativeMail' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="emailContacto-error"
                              className="error"
                              htmlFor="emailContacto"
                            >
                              {t('validaciones.corporative-mail')}
                            </label>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="u-text-right">
                  <button
                    id="datos-acceso-submit-btn"
                    type="submit"
                    className="btn btn-primary "
                  >
                    {t('datos.accessdata.update')}
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </section>
      ) : null}
      <ModalConfirmacion
        isBig={false}
        isSmall={false}
        textCentered
        showModal={emailContactoCambiado}
        setShowModal={setEmailContactoCambiado}
        title={t(title)}
        textHTMLContent={textForModalCambioEmail}
        doClose={acceptEmailSend}
        doAceptar={cambiarStyle}
        showCancel={false}
        acceptButtonTextKey={acceptButtonTextKey}
      />
    </>
  );
};

export default ContactEmailForm;
